import { Component } from '@angular/core';
import { svgBaseStyles, SvgComponent } from './svg-component';

@Component({
  selector: 'topo-door-svg',
  standalone: true,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="m 7.485591,0.38094746 c -0.06293,-0.053401 -0.13704,-0.091991 -0.21687,-0.112923 -0.07984,-0.020931 -0.16335,-0.02367 -0.24438,-0.00802 L 0.83681401,1.3850135 c -0.129512,0.02356 -0.246658,0.0918 -0.331042,0.19283 -0.084384,0.10104 -0.13066,0.22847 -0.130772,0.36011 v 9.5625005 c -2.5e-5,0.1235 0.040548,0.2435 0.115464,0.3416 0.074916,0.0981 0.180017,0.1688 0.2991,0.2012 l 6.18752699,1.6876 c 0.04825,0.0129 0.09798,0.0195 0.14793,0.0196 0.14919,0 0.29226,-0.0592 0.39775,-0.1647 0.10549,-0.1055 0.16476,-0.2486 0.16476,-0.3978 V 0.81294946 c 3e-5,-0.082404 -0.01803,-0.163809 -0.05293,-0.238459 -0.03489,-0.07465 -0.08576,-0.140722 -0.14901,-0.193543 z M 6.000021,8.687979 c 0,0.14919 -0.05926,0.29226 -0.16475,0.39775 -0.10549,0.10549 -0.24857,0.16475 -0.39775,0.16475 -0.14919,0 -0.29226,-0.05926 -0.39775,-0.16475 -0.10549,-0.10549 -0.16475,-0.24856 -0.16475,-0.39775 v -1.125 c 0,-0.14919 0.05926,-0.29226 0.16475,-0.39775 0.10549,-0.10549 0.24856,-0.16476 0.39775,-0.16476 0.14918,0 0.29226,0.05927 0.39775,0.16476 0.10549,0.10549 0.16475,0.24856 0.16475,0.39775 z"
        [attr.fill]="color()" />
      <path
        d="m 11.062561,12.062959 h -2.25 v -1.125 h 1.6875 V 3.0629585 h -1.6875 v -1.125 h 2.25 c 0.1492,0 0.2923,0.05926 0.3978,0.16475 0.1054,0.10549 0.1647,0.24857 0.1647,0.39775 v 9.0000005 c 0,0.1492 -0.0593,0.2923 -0.1647,0.3978 -0.1055,0.1055 -0.2486,0.1647 -0.3978,0.1647 z"
        [attr.fill]="color()" />
    </svg>
  `,
  styles: svgBaseStyles
})
export class DoorSVGComponent extends SvgComponent {}
